import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ErrorPage = ({ title, message }) => {
    return (_jsxs("div", { className: 'p-8 text-center', children: [_jsx("h2", { className: 'text-red-700', children: title }), _jsx("p", { className: 'mt-4', children: message })] }));
};
export default ErrorPage;
